import gsap from "gsap";

export class HeroImages {
  constructor() {
    this._images = document.querySelectorAll(".s-hero img");

    if (this._images.length) {
      this.init();
    }
  }

  init() {
    this._images.forEach((image, index) => {
      // Créer un overlay blanc pour chaque image
      const overlay = document.createElement("div");
      overlay.style.cssText = `
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: white;
        z-index: 1;
        pointer-events: none;
      `;

      // S'assurer que le parent a position relative
      const parent = image.parentElement;
      if (parent) {
        const parentPosition = window.getComputedStyle(parent).position;
        if (parentPosition === "static") {
          parent.style.position = "relative";
        }

        parent.insertBefore(overlay, image);

        let tl = gsap.timeline();

        image.style.opacity = "1";

        tl.from(overlay, {
          clipPath: "inset(0% -1% 0% 0%)",
        });

        tl.to(overlay, {
          clipPath: "inset(0% -1% 200px 0%)",
          duration: 1.3,
          ease: "power2.inOut",
          // delay: index * 0.1,
        });

        tl.to(overlay, {
          clipPath: "inset(0% -1% 100% 0%)",
          duration: 1,
          ease: "power2.inOut",
          delay: index * 0.1,
          onComplete: () => {
            overlay.remove();
          },
        });
      }
    });
  }
}
